export default __webpack_public_path__ + "static/media/chat6.bd8f339d.jpg";